import * as React from "react";
import {backend} from "../../../../../xconvert-backend";
import {authentication} from "../../../../../authentication";
import {SchedulerTaskConfig} from "../../../../../generated/api";
import {Icon} from "semantic-ui-react";

export function SchedulerTasksHealth() {

    const [errorTasks, setErrorTasks] = React.useState(null)

    React.useEffect(() => {

        async function loadSchedulerTasks() {

            let auth = backend.withTokenAuthHeader(authentication.token)

            let resp = (await backend.internalApi.fetchSchedulerTasks(auth))

            setErrorTasks(resp.configs.filter((task) => {
                return task.enabled == true &&
                (
                    task.state != SchedulerTaskConfig.StateEnum.SUCCESS &&
                    task.state != SchedulerTaskConfig.StateEnum.STARTED
                )
            }))
        }

        loadSchedulerTasks().then(_ => {})
    }, []);


    return <div style={{marginTop: "1.5em", marginBottom: "1.5em"}}>
        <h4>
            <Icon name="clock"/> Scheduler Tasks Health
        </h4>
        {errorTasks && errorTasks.length > 0 && <div>
            <h3 color={"red"}>Failed or Dead Tasks</h3>
            <ul>
                {errorTasks.map((task) => {
                        return <li key={task.id}>{task.taskName} - <a style={{backgroundColor: "red"}}>{task.state}</a></li>
                    }
                )}
            </ul>
        </div>}
        {errorTasks && errorTasks.length == 0 && <div>
            <h4>No Failed or Dead Tasks</h4>
        </div>}
    </div>
}